<template>
  <v-progress-circular indeterminate color="brand" size="16" :width="1" />
</template>

<script>
  export default {
  }
</script>



// WEBPACK FOOTER //
// src/components/elements/InlineSpinner.vue